module.exports = "a {\r\n  text-decoration: none;\r\n  color: white;\r\n}\r\n\r\na:hover, a:active {\r\n  color: lightblue;\r\n}\r\n\r\n.nav-caption {\r\n  display: inline-block;\r\n  padding-left: 6px;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation/sidenav-list/sidenav-list.component.css
// module id = ./src/app/navigation/sidenav-list/sidenav-list.component.css
// module chunks = main